var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoBig = function SvgLogoBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 69 69"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M61.252 0Q67.318 1.029 69 6.973v37.961H46.533V22.467H24.065V0zM23.29 22.467v23.242h23.242V68.95q-19.76.194-39.511-.387-5.29-1.846-6.585-7.36a969 969 0 0 1-.388-38.736z",
    clipRule: "evenodd"
  })));
};
export default SvgLogoBig;